import {ArrayUtils} from '@colonist/utils'
import {NestedReadonly, PlayerColor, TradeEmbargoState} from '@colonist/game-states'

export class TradeEmbargoControllerWriter {
    readonly embargoState: {[key in PlayerColor]?: TradeEmbargoState}

    constructor(players: PlayerColor[], embargoState: {[key in PlayerColor]?: TradeEmbargoState}) {
        this.embargoState = embargoState
        for(const player of players) {
            if(!this.embargoState[player]) {
                this.embargoState[player] = {activeEmbargosAgainst: []}
            }
        }
    }

    updatePlayer1EmbargoStateAgainstPlayer2(player1: PlayerColor, player2: PlayerColor) {
        if(player1 == player2) return
        TradeEmbargoControllerReader.doesPlayer1HaveAnEmbargoAgainstPlayer2(this.embargoState, player1, player2) ? this.endPlayer1EmbargoAgainstPlayer2State(player1, player2) : this.startPlayer1EmbargoAgainstPlayer2State(player1, player2)
    }

    private endPlayer1EmbargoAgainstPlayer2State(player1: PlayerColor, player2: PlayerColor) {
        const player1ActiveEmbargoes = TradeEmbargoControllerReader.getActiveEmbargoesForPlayer(this.embargoState, player1)
        ArrayUtils.removeElementFromArray(player1ActiveEmbargoes, player2)
    }

    private startPlayer1EmbargoAgainstPlayer2State(player1: PlayerColor, player2: PlayerColor) {
        const player1ActiveEmbargoes = TradeEmbargoControllerReader.getActiveEmbargoesForPlayer(this.embargoState, player1)
        player1ActiveEmbargoes.push(player2)
    }
}

export class TradeEmbargoControllerReader {
    static getNonEmbargoedPlayersForPlayer(embargoState: {[key in PlayerColor]?: NestedReadonly<TradeEmbargoState>}, player: PlayerColor): PlayerColor[] {
        const nonEmbargoedPlayers: PlayerColor[] = []
        const allPlayersInGame = Object.keys(embargoState).map((playerColor) => Number(playerColor) as PlayerColor)

        const activeEmbargoes = this.getActiveEmbargoesForPlayer(embargoState, player)
        for(const gamePlayer of allPlayersInGame) {
            if(gamePlayer == player) continue
            if(activeEmbargoes.includes(gamePlayer)) continue
            nonEmbargoedPlayers.push(gamePlayer)
        }
        return nonEmbargoedPlayers
    }

    static getActiveEmbargoesForPlayer(embargoState: {[key in PlayerColor]?: NestedReadonly<TradeEmbargoState>}, player: PlayerColor): PlayerColor[] {
        return embargoState[player]?.activeEmbargosAgainst ?? []
    }

    static didPlayerEmbargoAllOtherPlayers(embargoState: {[key in PlayerColor]?: NestedReadonly<TradeEmbargoState>}, player: PlayerColor): boolean {
        const allPlayersInGame = Object.keys(embargoState).map((playerColor) => Number(playerColor) as PlayerColor)
        const numberOfPlayers = allPlayersInGame.length
        if(numberOfPlayers == 1) return false

        return this.getActiveEmbargoesForPlayer(embargoState, player).length == numberOfPlayers - 1
    }

    static didEveryoneEmbargoPlayer(embargoState: {[key in PlayerColor]?: NestedReadonly<TradeEmbargoState>}, player: PlayerColor): boolean {
        const allPlayersInGame = Object.keys(embargoState).map((playerColor) => Number(playerColor) as PlayerColor)

        for(const gamePlayer of allPlayersInGame) {
            if(gamePlayer == player) continue
            if(!this.doesPlayer1HaveAnEmbargoAgainstPlayer2(embargoState, gamePlayer, player)) return false
        }
        return true
    }

    static doesPlayer1HaveAnEmbargoAgainstPlayer2(embargoState: {[key in PlayerColor]?: NestedReadonly<TradeEmbargoState>}, player1: PlayerColor, player2: PlayerColor): boolean {
        const player1ActiveEmbargoes = this.getActiveEmbargoesForPlayer(embargoState, player1)
        return player1ActiveEmbargoes.includes(player2)
    }
}
